// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"style-module__tableWrapper___1hge4","tableHeadline":"style-module__tableHeadline___1bDDr"};